import Model from "../../models/model";
import Vue from "vue";
import {ObjectHelper} from "../../helpers/objectHelper";
import {IServerData} from "../../interfaces/serverInterfaces";
import IRepo from "../../interfaces/repo";

export default class RepoFactory<T extends Model> {

  constructor(protected repo: IRepo<T>) {
  }

  module(): {} {
    return {
      namespaced: true,
      state: this.state(),
      getters: this.getters(),
      mutations: this.mutations(),
      actions: this.actions()
    };
  }

  private state(): { dic: {[key: string]: T}, repo: IRepo<T>} {
    return {
      dic: {},
      repo: this.repo,
    };
  }

  private getters() {
    return {
      all(state): Function {
        return (): T[] => {
          return ObjectHelper.toArray(state.dic);
        };
      },
      find(state): Function {
        return (id: string): T => {
          return state.dic[id];
        };
      },
      findBy(state): ((callback: (item: T) => boolean) => T) {
        return (callback: (item: T) => boolean): T => {
          for (const k in state.dic) {
            if (callback(state.dic[k])) {
              return state.dic[k]
            }
          }
          return null;
        }
      },
      // find item in repo by id or client_id
      findById(state): ((...ids: string[]) => T) {
        return (...ids: string[]): T => {
          const matchingId = ids.find(id => {
            return state.dic[id]
          })
          if (!matchingId) {
            for (const k in state.dic) {
              if (ids.includes(state.dic[k].id) || ids.includes(state.dic[k].client_id)) {
                return state.dic[k]
              }
            }
          } else {
            return state.dic[matchingId]
          }
          return null
        }
      },
      findWhere(state): ((callback: (item: T) => boolean) => T[]) {
        return (callback: (item: T) => boolean): T[] => {
          const results: T[] = [];
          for (let k in state.dic) {
            const item = state.dic[k]
            if (callback(item)) {
              results.push(item);
            }
          }
          return results;
        }
      }
    };
  }

  private mutations() {
    return {
      addForKey(state, {key, item}: { key: string, item: T }): void {
        Vue.set(state.dic, key, item);
      },
      add(state, item: T): void {
        Vue.set(state.dic, item.clientIdOrId, item);
      },
      remove(state, item: T): void {
        Vue.delete(state.dic, item.clientIdOrId);
      },
      removeWhereKey(state, key: string): void {
        Vue.delete(state.dic, key);
      }
    };
  }

  private actions() {
    return {
      // async doAction(store, {obj}): Promise<IServerData> {
      async save({state}, {obj, objJson}): Promise<IServerData> {
        const repo = state.repo;
        const response = await repo.provider.save(obj, objJson);
        const data = response[0];
        if (data.success) {
          repo.provider.createOrUpdateFrom(obj, data[repo.provider.modelRoot]);
        }
        return response;
      },
      async destroy({state}, {obj}): Promise<IServerData> {
        // Remove locally
        state.repo.remove(obj);
        // Remove on the server
        return state.repo.provider.destroy(obj);
      },
    };
  }
}
